<ng-container [formGroup]="instructionForm">
  <form [formGroup]="instructionForm" class="instruction-form">
    <div class="form-wrapper input-wrapper">
      <!-- Conditional fields based on selected type -->
      <ng-container [ngSwitch]="instructionForm.get('type')?.value"
                    class="instruction-definition-conditional-fields">

        <!-- Instruction AI Config Fields -->
        <ng-container>
          <!-- Model -->
          <div class="s-labels-wrapper form-field">
            <mat-label style="font-weight: bold">Model</mat-label>
            <div class="s-label">
              <ai-models
                (modelSelected)="modelSelected($event)"
                (temperatureChanged)="handleTemperatureChange($event)"
                (topPChanged)="handleTopPChange($event)"
              />
              @if (this.instructionForm.get('model')?.value?.accountName != '' &&
              this.instructionForm.get('model')?.value?.model != '') {
                @defer (when this.instructionForm.get('model')?.value) {
                  <span>{{ this.instructionForm.get('model')?.value?.accountName }}/{{
                      this.instructionForm.get('model')?.value?.model
                    }}</span>
                }
              }
            </div>
            <mat-hint>A model is a program or algorithm that uses incoming data to make
              informed decisions, predictions, or generate content.
            </mat-hint>
            @if ((this.instructionForm.get('model')?.value?.accountName === '' &&
              this.instructionForm.get('model')?.value?.model === '' ||
              this.instructionForm.get('model')?.value === null) &&
            this.instructionForm.get('model')?.touched) {
              <mat-error>Model is required</mat-error>
            }
          </div>

          <!-- Temperature -->
          <div class="s-labels-wrapper form-field">
            <mat-label style="font-weight: bold">Temperature</mat-label>
            <div>
              <mat-slider min="0.1" max="1" step="0.1" showTickMarks discrete [disabled]="isGpt5Model()">
                <input matSliderThumb formControlName="temperature"
                       (valueChange)="handleTemperatureChange($event)">
              </mat-slider>
            </div>
            <mat-hint>This affects the randomness of the output. Low values like 0.2 make
              the
              output more focused and deterministic, while high values (greater than 1.0) produce more
              diverse and creative outputs.
            </mat-hint>
          </div>

          <!-- Top P -->
          <div class="s-labels-wrapper form-field">
            <mat-label style="font-weight: bold">Top P</mat-label>
            <div>
              <mat-slider min="0.1" max="1" step="0.1" showTickMarks discrete [disabled]="isGpt5Model()">
                <input matSliderThumb formControlName="topP"
                       (valueChange)="handleTopPChange($event)">
              </mat-slider>
            </div>
            <mat-hint>This controls how deterministic the model is. If you are looking for
              more
              exact and factual answers, keep the value low. If you are looking for more diverse
              responses, increase this value.
            </mat-hint>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </form>
</ng-container>
